import { Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { PaymentCorrelationRequest, PaymentCorrelationResponse, } from "@app/models/PaymentCorrelation";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class PaymentCorrelationApi extends HOAApiBase {
    constructor() {
        super('PaymentCorrelationApi');
    }

    createCorrelationId(anonymous: boolean, correlationRequest: PaymentCorrelationRequest): Observable<PaymentCorrelationResponse> {
        const serviceName = anonymous ? "HOAPass" : "hoa-gateway";
        const url = this.createUrl(serviceName, "/payments/correlation-id");

        return this.http.post<PaymentCorrelationResponse>(url, correlationRequest);
    }
}
